import alt from 'components/Dispatcher';
import AccountSource from 'sources/AccountSource';
import generateAsyncActions from 'utils/generateAsyncActions';

class AccountActions {
  constructor() {
    this.generateActions(
      ...generateAsyncActions('accountHasSalesforce', 'fetchCreatedDate', 'hasSlack')
    );
  }

  accountHasSalesforce() {
    return dispatch => {
      dispatch();
      return AccountSource.accountHasSalesforce().then(
        this.accountHasSalesforceSuccess,
        this.accountHasSalesforceError
      );
    };
  }

  fetchCreatedDate() {
    return dispatch => {
      dispatch();
      return AccountSource.fetchCreatedDate().then(
        this.fetchCreatedDateSuccess,
        this.fetchCreatedDateError
      );
    };
  }

  hasSlack() {
    return dispatch => {
      dispatch();
      return AccountSource.hasSlack().then(this.hasSlackSuccess, this.hasSlackError);
    };
  }
}

export default alt.createActions(AccountActions);
